module.exports = __webpack_public_path__ + "static/media/peterArt5.45674776.jpg";